import { useQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';

import { fetchSnakeMetaV2 } from '~/services/overview-widget/overview-widget-service';

const QUERY_KEY_FETCH_SNAKE_META_V2 = 'QUERY_KEY_FETCH_SNAKE_META_V2';

export const useFetchSnakeMetaV2 = (snake: string) =>
  useQuery({
    queryKey: [QUERY_KEY_FETCH_SNAKE_META_V2, snake],
    queryFn: ({ signal }) => fetchSnakeMetaV2(snake, signal),
    select: data => ({
      meta: data.data?.[snake],
    }),
    staleTime: getTimeTillEndOfDayMs(),
  });
